import { render, staticRenderFns } from "./BaseSelect2.vue?vue&type=template&id=788d9b50&scoped=true"
import script from "./BaseSelect2.vue?vue&type=script&lang=js"
export * from "./BaseSelect2.vue?vue&type=script&lang=js"
import style0 from "./BaseSelect2.vue?vue&type=style&index=0&id=788d9b50&prod&lang=css"
import style1 from "./BaseSelect2.vue?vue&type=style&index=1&id=788d9b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788d9b50",
  null
  
)

export default component.exports